@if (desktopMode) {
  <app-ui-button
    buttonType="icon-button"
    icon="{{ isHandset() ? 'menu' : drawer.opened ? 'switch_right' : 'switch_left' }}"
    iconVariant="legacy"
    (click)="toggleMainNav()"
    class="toggle-button medium-icon"
    [ngClass]="{
      'sidenav-opened': drawer.opened,
      'sidenav-closed': !drawer.opened,
      'toolbar-collapsed': isToolbarCollapsed(),
    }"
    [matTooltip]="(drawer.opened ? 'collapseSidenav' : 'expandSidenav') | translate"
  ></app-ui-button>
}
<mat-sidenav-container
  class="sidenav-container main-dark-background"
  [class.sidenav-closed]="!drawer.opened"
  [class.mobile-sidenav-opened]="!desktopMode && drawer.opened"
>
  <mat-sidenav
    #drawer
    class="sidenav main-sidenav"
    fixedInViewport
    [fixedTopGap]="desktopMode ? 0 : 40"
    [attr.role]="isHandset() ? 'dialog' : 'navigation'"
    [mode]="isHandset() ? 'over' : 'side'"
    [opened]="isHandset() === false && desktopMode"
  >
    <div class="main-menu-container">
      <mat-toolbar
        class="main-sidenav logo-toolbar"
        [ngClass]="desktopMode ? '' : 'no-logo-height'"
      >
        @if (desktopMode) {
          <div class="logo-container">
            @if (depId !== ALL_DEPS_TOKEN) {
              <img
                [src]="
                  !!isDarkMode()
                    ? '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-LightGrey.svg'
                    : '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-DarkGrey.svg'
                "
                class="logo-image"
                alt="ccom logo"
                routerLink="/"
              />
            } @else {
              <div class="logo-container">
                <img
                  [src]="
                    !!isDarkMode()
                      ? '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-LightGrey.svg'
                      : '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-DarkGrey.svg'
                  "
                  class="logo-image"
                  alt="ccom logo"
                />
              </div>
            }
          </div>
          @if (isInAdmin) {
            <ng-container [ngTemplateOutlet]="adminLabelTemplate"></ng-container>
          }
        } @else {
          @if (
            {
              selectedDepartment: selectedDepartment(),
              departmentList: sortedDepartments(),
            };
            as departments
          ) {
            <div class="mobile-dep-selector-container" (click)="openDepartmentSelectorMobile()">
              <img
                width="30"
                height="30"
                [src]="
                  departments.selectedDepartment?.id === ALL_DEPS_TOKEN
                    ? allDepsIconPath
                    : (departments.selectedDepartment?.logo | appendDomain) ||
                      departmentPlaceHolderIconPath
                "
                class="mobile-dep-sel-picture"
                alt="vessel picture"
              />
              <span class="mobile-dep-name-row">
                <span class="mobile-dep-text">{{ departments.selectedDepartment?.name }}</span>
                @if (isDepartmentPaused(departments.selectedDepartment)) {
                  <app-department-paused-badge
                    class="mobile-dep-paused-badge"
                    [iconOnly]="true"
                  ></app-department-paused-badge>
                }
              </span>
              <mat-icon class="mobile-dep-sel-icon">keyboard_arrow_right</mat-icon>
            </div>
          }
        }
      </mat-toolbar>
      <app-menu-list
        [ngClass]="{
          'menu-list-admin': isInAdmin,
          'menu-list-admin-mobile': !desktopMode,
        }"
      ></app-menu-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content [class.overflow-hidden]="isToolbarAnimating">
    @if (desktopMode) {
      <app-ui-button
        buttonType="icon-button"
        icon="switch_right"
        iconVariant="legacy"
        (click)="toggleToolbar()"
        class="toolbar-collapse-button medium-icon"
        [class.toolbar-collapsed]="isToolbarCollapsed()"
        [matTooltip]="(isToolbarCollapsed() ? 'expandToolbar' : 'collapseToolbar') | translate"
      ></app-ui-button>
    }
    @if (!desktopMode) {
      <app-survey-banner
        class="mobile-survey-banner"
        [class.mobile-detail-toolbar-hidden]="mobileDetailViewState().hideMobileToolbar"
      ></app-survey-banner>
    }
    <mat-toolbar
      class="top-toolbar"
      [@slideDown]="!isToolbarCollapsed() || !desktopMode"
      [class.mobile-toolbar]="!desktopMode"
      [class.mobile-toolbar--structure-hint]="showStructureHint()"
      [class.mobile-detail-toolbar-hidden]="mobileDetailViewState().hideMobileToolbar"
    >
      @if (desktopMode) {
        <app-department-dropdown></app-department-dropdown>
        <app-survey-banner class="header-survey-banner"></app-survey-banner>
        @if (!isToolbarCollapsed()) {
          <ng-container *ngTemplateOutlet="desktopCartTemplate"></ng-container>
        }
        <div class="right-nav-container">
          <!-- <app-global-search></app-global-search> -->
          <mat-icon
            (click)="goToCCOMDocs()"
            [matTooltip]="'goToCCOMDocumentation' | translate"
            matTooltipMobileTap="off"
          >
            help_outline
          </mat-icon>
        </div>
        <div class="icons-container">
          <app-language-selector></app-language-selector>
          <app-logged-in-as-popup></app-logged-in-as-popup>
        </div>
      } @else {
        <span class="mobile-header-container" [class.mobile-header-container--admin]="isInAdmin">
          <span
            class="left-side-mobile-cluster"
            [class.left-side-mobile-cluster--with-structure]="showMobileStructureToggle"
          >
            <span class="left-side-mobile-container">
              <mat-icon
                (click)="toggleMainNav()"
                class="mobile-header-icon"
                [class.mobile-header-icon--active]="drawer.opened"
              >
                menu
              </mat-icon>
            </span>
            @if (showMobileStructureToggle) {
              <div class="mobile-structure-toggle-wrap" (pointerdown)="dismissStructureHint()">
                <mat-icon
                  class="mobile-header-icon mobile-structure-toggle"
                  [class.mobile-header-icon--active]="innerMenuOpened"
                  (click)="toggleInnerMenu()"
                >
                  account_tree
                </mat-icon>
                @if (showStructureHint()) {
                  <app-first-visit-hint
                    [hintId]="menuStructureHintId"
                    titleKey="menuStructureHintTitle"
                    arrowLeft="0.75rem"
                  ></app-first-visit-hint>
                }
              </div>
            }
          </span>
          <img
            [src]="
              !!isDarkMode()
                ? '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-LightGrey.svg'
                : '../../../../assets/icons/ccom-logo-svg/CCOM-primary-logo-DarkGrey.svg'
            "
            class="mobile-logo-image"
            alt="ccom logo"
            routerLink="/"
          />
          @if (isInAdmin) {
            <ng-container [ngTemplateOutlet]="adminLabelTemplate"></ng-container>
          }
          <span class="right-side-mobile-container">
            @if (
              showCartButton && currentDepartmentId() && currentDepartmentId() !== ALL_DEPS_TOKEN
            ) {
              <span class="mobile-cart-button-container">
                <app-ui-button
                  data-cart-entry-point
                  class="mobile-cart-button mobile-header-icon"
                  buttonType="icon-button"
                  icon="shopping_cart"
                  tooltip="{{ 'viewCart' | translate }}"
                  (click)="openCartDialog()"
                ></app-ui-button>
                @if (cartCount() > 0) {
                  <span class="mobile-cart-count">{{ cartCount() }}</span>
                }
              </span>
            }
            @if (!userAccess()?.profilePictureMiniature) {
              <mat-icon class="mobile-header-icon" (click)="openUserProfileMobileDialog()">
                account_circle
              </mat-icon>
            }
            @if (userAccess()?.profilePictureMiniature) {
              <img
                [src]="userAccess()?.profilePictureMiniature?.link | appendDomain"
                alt="profile picture"
                class="mobile-header-icon"
                (click)="openUserProfileMobileDialog()"
              />
            }
          </span>
        </span>
      }
    </mat-toolbar>
    @if (desktopMode) {
      <div class="breadcrumb-container" [class.toolbar-collapsed]="isToolbarCollapsed()">
        <div class="breadcrumb-content">
          <app-breadcrumb></app-breadcrumb>
        </div>
        @if (isToolbarCollapsed()) {
          <ng-container
            *ngTemplateOutlet="desktopCartTemplate; context: { collapsed: true }"
          ></ng-container>
        }
      </div>
    }
    <mat-sidenav-container
      class="sidenav-inner"
      [class.sidenav-inner-mobile]="!desktopMode"
      [class.toolbar-collapsed]="isToolbarCollapsed()"
      [class.mobile-detail-shell-active]="mobileDetailViewState().active"
      [class.mobile-detail-toolbar-hidden]="mobileDetailViewState().hideMobileToolbar"
      autosize
    >
      <mat-sidenav
        #inner
        [mode]="desktopMode ? 'side' : 'push'"
        [(opened)]="innerMenuOpened"
        class="inner-sidenav"
        [class.menu-tree-nav-mode]="!isInAdmin && !adminInnerModuleName()?.includes('users')"
        (openedStart)="structureMenu?.onSidebarOpening()"
        (opened)="structureMenu?.onSidebarOpened()"
      >
        @if (!isInAdmin && !(!isInAdmin && adminInnerModuleName()?.includes('users'))) {
          <app-menu-tree-structure
            [showFunctionalButtons]="false"
            [menuItemsAsRouting]="true"
            [menuMode]="true"
            [depId]="depId"
            [searchEnabled]="!desktopMode"
            (menuItemSelected)="closeInnerMenuOnMobile()"
          ></app-menu-tree-structure>
        } @else {
          <app-admin-inner-nav
            [adminInnerModuleName]="adminInnerModuleName()"
            (itemSelected)="closeInnerMenuOnMobile()"
          ></app-admin-inner-nav>
        }
      </mat-sidenav>
      <mat-sidenav-content
        class="inner-sidenav-content"
        [class.overflow-hidden]="isToolbarAnimating && hideScrollOnToolbarAnimationInModule"
        #innerNavContent
      >
        <ng-content></ng-content>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (!!!isHandset() && desktopMode) {
  <app-ui-button
    #innerNavToggleButton
    class="toggle-secondary-sidenav-button"
    [class.closed]="!inner.opened"
    [class.cdk-visually-hidden]="!showSecondarySidenav"
    buttonType="icon-button"
    icon="{{ isHandset() ? 'menu' : inner.opened ? 'chevron_left' : 'chevron_right' }}"
    (click)="inner.toggle()"
  ></app-ui-button>
}
@if (useTextControl && !forceReload) {
  <div class="text-control-reusable-container">
    @if (textControl.isInitialized) {
      <tx-document-editor
        appElementResize
        id="text-control-editor"
        class="cdk-visually-hidden"
        width="100%"
        [height]="textControl.isFullscreen ? '700px' : '100vh'"
        [saveDocumentQuestionDialogEnabled]="false"
        [webSocketURL]="url"
        [class.disabled]="textControl.isEditorDisabled"
        [class.ribbon-loading]="!textControl.ribbonBarLoaded"
        [class.document-loading]="textControl.isDocumentLoading"
        (elementResized)="textControl.refreshLayout()"
      ></tx-document-editor>
    }
  </div>
}
<ng-template #adminLabelTemplate>
  <div class="admin-label-container">
    <mat-icon>settings</mat-icon>
    <span class="admin-label">{{ 'adminSettings' | translate }}</span>
  </div>
</ng-template>
<ng-template #desktopCartTemplate let-collapsed="collapsed">
  @if (showCartButton && currentDepartmentId() && currentDepartmentId() !== ALL_DEPS_TOKEN) {
    <div class="desktop-cart-container" [class.desktop-cart-container--collapsed]="collapsed">
      <app-ui-button
        data-cart-entry-point
        class="desktop-cart-button"
        buttonType="mat"
        [text]="('cart' | translate) + ' (' + cartCount() + ')'"
        icon="shopping_cart"
        [matMenuTriggerFor]="cartMenu"
        #cartMenuTrigger="matMenuTrigger"
      ></app-ui-button>
      <mat-menu
        #cartMenu="matMenu"
        class="cart-menu"
        xPosition="before"
        yPosition="below"
        [overlapTrigger]="false"
      >
        <app-cart-content
          variant="dropdown"
          (click)="$event.stopPropagation()"
          (mousedown)="$event.stopPropagation()"
          (closeRequested)="cartMenuTrigger.closeMenu()"
        ></app-cart-content>
      </mat-menu>
    </div>
  }
</ng-template>
